//#region src/variants/variants_popover.js
var variants_popover_default = {
	default: {
		props: { open: { initialValue: false } },
		slots: {
			anchor: { initialValue: "<dt-button>View Popover</dt-button>" },
			content: { initialValue: "<p>This is content rendered within the popover.</p>" }
		}
	},
	"with header": {
		props: { open: { initialValue: false } },
		slots: {
			anchor: { initialValue: "<dt-button>View Popover</dt-button>" },
			headerContent: { initialValue: "<div class=\"d-w100p\">This is the header</div>" },
			content: { initialValue: "<p>This is content rendered within the popover.</p>" }
		}
	},
	"fallback placement": {
		props: {
			open: { initialValue: false },
			fallbackPlacements: { initialValue: ["top"] }
		},
		slots: {
			anchor: { initialValue: "<dt-button>fallback placement: top</dt-button>" },
			content: { initialValue: "<p>This is content rendered within the popover.</p>" }
		}
	},
	"small padding": {
		props: {
			open: { initialValue: false },
			padding: { initialValue: "small" }
		},
		slots: {
			anchor: { initialValue: "<dt-button>View Popover</dt-button>" },
			content: { initialValue: "<p>This is content rendered within the popover.</p>" }
		}
	}
};
//#endregion
export { variants_popover_default as default };

//# sourceMappingURL=variants_popover.js.map